import { render, staticRenderFns } from "./RedirectTelegram.vue?vue&type=template&id=780a93ff&scoped=true&"
import script from "./RedirectTelegram.vue?vue&type=script&lang=js&"
export * from "./RedirectTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a93ff",
  null
  
)

export default component.exports